<template>
  <v-container style="height: 100vh; margin-top: 40vh" class="text-center">
    <v-progress-circular
      :width="3"
      color="red"
      indeterminate
    ></v-progress-circular>
    <h5 class="pt-5 subtitle-2 grey--text text--darken-3">Logging out</h5>
  </v-container>
</template>
<script>
export default {
  created() {
    this.$auth.logout().then(
      (response) => {
        if (response == "success") {
          this.$router.push("/login");
        } else {
          this.$router.go("-1");
        }
      },
      () => {
        this.$router.go("-1");
      }
    );
  },
};
</script>
